import { render, staticRenderFns } from "./TkPackbackTours.vue?vue&type=template&id=12fb2626&"
import script from "./TkPackbackTours.vue?vue&type=script&lang=js&"
export * from "./TkPackbackTours.vue?vue&type=script&lang=js&"
import style0 from "./TkPackbackTours.vue?vue&type=style&index=0&id=12fb2626&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports